import script from "./msgVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./msgVideo.vue?vue&type=script&setup=true&lang=js"

import "./msgVideo.vue?vue&type=style&index=0&id=444156cc&scoped=true&lang=css"
import "./msgVideo.vue?vue&type=style&index=1&id=444156cc&lang=css"

import exportComponent from "/Users/nasinet/hujing_pro/hj_pro_h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-444156cc"]])

export default __exports__